import $ from 'jquery';

import Component from '../Component';

export default class Parallax extends Component {
    constructor(theme, element) {
        super(theme, element);

        this.theme = theme;
        this.element = element;
        this.$element = $(element);
        this.img = element.querySelector(".img");
        this.active = false;

        // Wait for image load
        this.$element.children(".img")
            .one("load", () => {
                this.onWindowResize();
                this.img.style.display = 'block';
            })
            .each(function() {
                if (this.complete || !this.src) {
                    $(this).trigger('load');
                }
            });

        window.addEventListener('scroll', this.update.bind(this), {
            capture: true,
            passive: true
        });
    }

    onWindowResize = () => {
        this.img_height = $(this.img).height();
        this.container_height = (this.$element.height() > 0 ? this.$element.height() : this.img_height) || 500;

        // Parallax is disabled on mobile
        this.active = !window.matchMedia("screen and (max-width: 767px)").matches;
        this.update();
    }

    update = () => {
        if (!this.active) {
            this.img.style.transform = "";
            return;
        }
        var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

        var parallax_dist = this.img_height - this.container_height;
        var top = this.element.getBoundingClientRect().top + scrollTop;
        var bottom = top + this.container_height;
        var windowHeight = window.innerHeight;
        var windowBottom = scrollTop + windowHeight;
        var percentScrolled = (windowBottom - top) / (this.container_height + windowHeight);
        var parallax = parallax_dist * percentScrolled;

        if ((bottom > scrollTop) && (top < (scrollTop + windowHeight))) {
            this.img.style.transform = "translate3D(-50%," + parallax + "px, 0)";
        }
    }
}
